import { NullableClassName } from '@squareup/dex-types-shared-ui';
import { Box } from '@squareup/dex-ui-shared-base';
import { TrackedBox } from '@squareup/dex-ui-user-interaction-publisher';
import clsx from 'clsx';
import React, { FC, ReactNode } from 'react';

import styles from './content-layout.module.css';

interface Props {
  apiSelectors?: ReactNode | undefined;
  fieldContent?: ReactNode | undefined;
  requestResponseContent?: ReactNode | undefined;
}

const ApiExplorerContentLayout: FC<Props & NullableClassName> = ({
  apiSelectors,
  fieldContent,
  requestResponseContent,
}) => {
  return (
    <Box className={clsx(styles.grid)}>
      <TrackedBox
        padding={{ vertical: '1.5x' }}
        border={{ line: { top: 'standard', bottom: 'standard' } }}
        className={clsx(styles['grid-selectors-area'])}
        trackingId="selectors"
      >
        <Box className={clsx(styles.shift, styles.inner)}>{apiSelectors}</Box>
      </TrackedBox>
      <TrackedBox
        padding={{ top: '3x', right: '3x' }}
        border={{ line: { right: 'standard' } }}
        className={clsx(styles['grid-fields-area'])}
        trackingId="fields"
      >
        <Box className={styles['shift-left']}>{fieldContent}</Box>
      </TrackedBox>
      <TrackedBox
        padding={{ top: '3x', left: '3x' }}
        className={clsx(styles['grid-req-resp-area'], styles['shift-right'])}
        trackingId="request-response"
      >
        {requestResponseContent}
      </TrackedBox>
      {/* We must ensure there's a bottom border extending across the page. Easiest to do it here */}
      <Box
        className={styles['grid-bottom-border-area']}
        border={{ line: { bottom: 'standard' } }}
      >
        <Box className={styles.shift}></Box>
      </Box>
    </Box>
  );
};

export { ApiExplorerContentLayout };
